module.exports = __webpack_public_path__ + "media/src/img/arrow-select-d1c183dd63d7b4f193712669d9ad21d5.png";